import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface UseViewInvoicesStore {
  loading: boolean;
  data: string;
  error: string | null;
  viewInvoice: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useViewInvoicesStore = create<UseViewInvoicesStore>((set, get) => ({
  loading: false,
  data: '',
  error: null,

  viewInvoice: async (cardId, signal) => {
    try {
      set({ loading: true, data: '', error: null });
      const result = await CardsApi.downloadInvoice(cardId, signal);
      set({ loading: false, data: URL.createObjectURL(result.data) });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => {
    URL.revokeObjectURL(get().data);
    set({ loading: false, data: '', error: null });
  },
}));
